import type { HumidityLevelContainerDto, HumidityLevelDto } from "../../generated/client/octalog-service";

import { useGetHumidityLevels } from "./useGetHumidityLevels";
import { useIdToNameTranslator } from "./useIdToNameTranslator";

/**
 * Hook to get a function that translates a humidity level ID to its translated name.
 * Fetches humidity levels using `useGetHumidityLevels`.
 *
 * @returns {(humidityLevelId: number | undefined) => string | number} Function to translate the ID.
 */
export const useHumidityLevelIdTranslator = (): ((humidityLevelId: number | undefined) => string | number) => {
  const humidityLevelsQuery = useGetHumidityLevels();

  return useIdToNameTranslator<HumidityLevelContainerDto, HumidityLevelDto, "humidityLevelId", "name">(
    humidityLevelsQuery,
    (data) => data?.humidityLevels, // Extractor function
    "humidityLevelId",
    "name",
  );
};
